module.exports = __webpack_public_path__ + "img/fingerprint.7448a74a.gif";